var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-select',_vm._b({staticClass:"type-selector",attrs:{"options":_vm.$attrs.options || [
    { label: 'GMV', value: 'GMV' },
    { label: 'NMV', value: 'NMV' },
    { label: 'Total Orders', value: 'ORDERS' },
  ],"size":"small","dropdown-match-select-width":false},on:{"change":(value, $event) => _vm.$emit('input', value, $event)}},'a-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }